import { defineMessages } from "@formatjs/intl"
import type { FullServiceHistoryOptions } from "./FullServiceHistoryOptions"

export const fullServiceHistoryMessages = defineMessages<FullServiceHistoryOptions>({
	COMPLETE: {
		defaultMessage: "Yes, every service done",
		id: "conditionAndHistory.fullServiceHistory.complete",
	},
	INCOMPLETE: {
		defaultMessage: "One or more services are not known",
		id: "conditionAndHistory.fullServiceHistory.incomplete",
	},
})
